<template>
<div class="card-item" @click="$emit('add-to-cart',product)">
    <div class="card-title">{{product.name}}</div>
    <p>{{product.price | numFormat('0,0.00')}} <small>บาท</small> </p>
</div>

</template>
<script>
export default {
  name: "carditem",
  props:[
    "product" , "disabled"
  ], 
  filters: {
    toFixed: function (price,limit) {
      return price.toFixed(limit);
    }
  },
};
</script>
<style>
</style>
